export const PATROL_ROUTES = {
  __ROOT__: '/patrol',
  CURRENT_ACTIVITY: '/patrol/today',
  CURRENT_ACTIVITY_PATROL_ROUTE: '/patrol/today/route/:patrolRouteId',
  CURRENT_ACTIVITY_PATROL_ROUTE_RUN: '/patrol/today/run/:patrolRouteRunId',
  IN_PROGRESS: '/patrol/in-progress',
  IN_PROGRESS_RUN: '/patrol/in-progress/:patrolRouteRunId',
  MY_PATROL_ROUTE_RUN: '/patrol/my-runs/:patrolRouteRunId',
  MY_PATROL_ROUTE_RUNS: '/patrol/my-runs',
  PAST_PATROL_ROUTE: '/patrol/past/:pastPatrolRouteId',
  PAST_PATROL_ROUTES: '/patrol/past',
  PATROL_ROUTE: '/patrol/routes/:patrolRouteId',
  PATROL_ROUTE_IN_PROGRESS: '/patrol/routes/:patrolRouteId/in-progress',
  PATROL_ROUTE_IN_PROGRESS_RUN:
    '/patrol/routes/:patrolRouteId/in-progress/:patrolRouteRunId',
  PATROL_ROUTE_INFO: '/patrol/routes/:patrolRouteId/info',
  PATROL_ROUTE_PAST: '/patrol/routes/:patrolRouteId/past',
  PATROL_ROUTE_PAST_RUN: '/patrol/routes/:patrolRouteId/past/:patrolRouteRunId',
  PATROL_ROUTES: '/patrol/routes',
}
